import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

// Fires a GA page_view on every route change (SPA-aware) and
// scrolls to the top of the page for a clean navigation experience.
export default function RouteAnalytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
}
